import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-vision",
  "use": "icon-vision-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"icon-vision\"><path d=\"M993 0L31 558.5l279.3 124.2 558.5-527.5-434.4 589.5V1024l155.2-217.2 279.2 124.1z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol